var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkFukidashi1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57.69 34.53",
    style: {
      enableBackground: "new 0 0 57.69 34.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#603813;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.05,
    y: -10.08,
    transform: "matrix(0.4238 -0.9058 0.9058 0.4238 10.7497 36.4826)",
    className: "st0",
    width: 2,
    height: 39.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.09,
    y: -5.49,
    transform: "matrix(0.2889 -0.9574 0.9574 0.2889 -1.9658 44.6815)",
    className: "st0",
    width: 2,
    height: 58.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkFukidashi1);
export default __webpack_public_path__ + "static/media/talk-fukidashi-1.515b837ab64e7aab1c7f17f472bd0d49.svg";
export { ForwardRef as ReactComponent };